import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.fabbench.objective');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-fabbench-objective',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.fabbench.objective/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.benchmark-page {
  min-height: 100vh;
  background: radial-gradient(circle at 90% 0, rgba(109, 74, 255, 0.09), transparent 26rem), #f8fafc;
}

.progress-fill {
  transition: width 220ms ease;
}

.result-row {
  transition: background-color 140ms ease;
}

.result-row:hover {
  background: #f8fafc;
}

.truncate-answer {
  max-width: 18rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.manual-review-panel {
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.28), 0 0 0 100vmax rgba(15, 23, 42, 0.42);
}

@media (max-width: 767px) {
  .details-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}`],
})
export class PageFabbenchObjectiveComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public typeOptions: any[] = [
        { value: 'ALL', label: '전체 OBJECTIVE' },
        { value: 'Judge', label: '[Judge]' },
        { value: 'Choice', label: '[Choice]' },
        { value: 'Fill', label: '[Fill]' },
        { value: 'Calculation', label: '[Calculate]' }
    ];
    public filterOptions: any[] = [
        { value: 'ALL', label: '전체' },
        { value: 'ISSUES', label: '검토 필요' },
        { value: 'WRONG', label: '오답만' },
        { value: 'ERRORS', label: '오류만' },
        { value: 'GPT_PASS', label: 'GPT 전환 PASS' },
        { value: 'GPT_AMBIGUOUS', label: 'GPT 모호' },
        { value: 'GPT_ERRORS', label: 'GPT 오류' },
        { value: 'MANUAL_PASS', label: '수동 PASS' },
        { value: 'PASS', label: 'PASS 전체' }
    ];
    public selectedType: string = 'ALL';
    public resultFilter: string = 'ALL';
    public benchmark: any = {
        available: false,
        counts: {},
        total_objective: 0,
        model: 'gemma4:26b-a4b-it-q8_0',
        scoring_version: 'objective-v2',
        temperature: 0,
        rag_enabled: false,
        context_enabled: false,
        stream: false,
        gpt_assisted: {
            pilot_limit: 5,
            openai_judge: { model: '', api_key_configured: false }
        }
    };
    public objectiveModels: any[] = [
        {
            name: 'gemma4:26b-a4b-it-q8_0',
            label: 'Gemma4 26B',
            description: '기존 OBJECTIVE 기준 모델 · 25.8B · Q8_0',
            available: null
        },
        {
            name: 'qwen3.8:27b',
            label: 'Qwen 3.8 27B',
            description: 'Ollama 실조회 모델 · 27.3B · Q4_K_M',
            available: null
        }
    ];
    public selectedModel: string = 'gemma4:26b-a4b-it-q8_0';
    public runModel: string = '';
    public modelListError: string = '';
    public cases: any[] = [];
    public results: any[] = [];
    public summary: any = this.emptySummary();
    public loading: boolean = true;
    public running: boolean = false;
    public cancelRequested: boolean = false;
    public activeCase: any = null;
    public selectedResult: any = null;
    public manualReviewNote: string = '';
    public error: string = '';
    public notice: string = '';
    public savedFiles: any[] = [];
    public savedRuns: any[] = [];
    public selectedRunId: string = '';
    public savedGptRuns: any[] = [];
    public selectedGptRunId: string = '';
    public sourceRunId: string = '';
    public sourceBaselineName: string = '';
    public runStartedAt: string = '';
    public runCompletedAt: string = '';
    public gptSummary: any = this.emptyGptSummary();
    public gptRunning: boolean = false;
    public gptPilotCompleted: boolean = false;
    public gptActiveResult: any = null;
    public gptRunScope: string = 'pilot_5';
    public gptRunStartedAt: string = '';
    public gptRunCompletedAt: string = '';
    public gptSavedFiles: any[] = [];

    public async ngOnInit() {
        await this.service.init();
        await this.loadBenchmark();
    }

    public async loadBenchmark() {
        if (this.running || this.gptRunning) return;
        this.loading = true;
        this.error = '';
        this.notice = '';
        await this.service.render();
        const types = this.selectedType === 'ALL' ? [] : [this.selectedType];
        const response: any = await wiz.call('benchmark', { types: JSON.stringify(types) });
        if (response && response.code === 200) {
            this.benchmark = response.data.benchmark || this.benchmark;
            this.cases = response.data.cases || [];
        } else {
            this.cases = [];
            this.error = this.errorMessage(response, 'FAB-Bench OBJECTIVE 데이터셋을 불러오지 못했습니다.');
        }
        this.resetRun();
        await this.loadObjectiveModels();
        await this.loadSavedRuns();
        await this.loadSavedGptRuns();
        this.loading = false;
        await this.service.render();
    }

    public async changeType() {
        await this.loadBenchmark();
    }

    public async loadObjectiveModels() {
        this.modelListError = '';
        const response: any = await wiz.call('models', {});
        if (response && response.code === 200) {
            this.objectiveModels = response.data.models || this.objectiveModels;
            const selected = this.objectiveModels.find(
                (item: any) => item.name === this.selectedModel && item.available
            );
            if (!selected) {
                const defaultModel = response.data.default_model || this.benchmark.model;
                const fallback = this.objectiveModels.find(
                    (item: any) => item.name === defaultModel && item.available
                ) || this.objectiveModels.find((item: any) => item.available);
                if (fallback) this.selectedModel = fallback.name;
            }
        } else {
            this.objectiveModels = this.objectiveModels.map((item: any) =>
                Object.assign({}, item, { available: false })
            );
            this.modelListError = this.errorMessage(
                response,
                'Ollama 평가 모델 목록을 확인하지 못했습니다.'
            );
        }
    }

    public selectedModelInfo() {
        return this.objectiveModels.find(
            (item: any) => item.name === this.selectedModel
        ) || {};
    }

    public selectedModelAvailable() {
        return this.selectedModelInfo().available === true;
    }

    public activeModelName() {
        return this.runModel || this.selectedModel;
    }

    public modelLabel(name?: string) {
        const modelName = name || this.activeModelName();
        const model = this.objectiveModels.find((item: any) => item.name === modelName);
        return model ? model.label : modelName;
    }

    public async loadSavedRuns() {
        const response: any = await wiz.call('runs', {});
        this.savedRuns = response && response.code === 200
            ? response.data.runs || []
            : [];
        if (!this.savedRuns.some((run: any) => run.run_id === this.selectedRunId)) {
            this.selectedRunId = this.savedRuns.length ? this.savedRuns[0].run_id : '';
        }
    }

    public async loadSavedRun() {
        if (!this.selectedRunId || this.running || this.gptRunning) return;
        this.loading = true;
        this.error = '';
        this.notice = '';
        await this.service.render();
        const response: any = await wiz.call('load', { run_id: this.selectedRunId });
        if (response && response.code === 200 && response.data.run) {
            const document = response.data.run;
            this.resetRun();
            this.sourceRunId = document.run_id || this.selectedRunId;
            this.sourceBaselineName = document.baseline_name || '';
            const execution = document.execution || {};
            this.runModel = execution.model || document.model || this.benchmark.model;
            if (this.objectiveModels.some((item: any) => item.name === this.runModel)) {
                this.selectedModel = this.runModel;
            }
            this.runStartedAt = execution.started_at || '';
            this.runCompletedAt = execution.completed_at || document.generated_at || '';
            this.results = (document.results || []).map((row: any) => Object.assign({}, row, {
                automatic_status: row.automatic_status || row.status,
                manual_review: row.manual_review || {}
            }));
            this.cases = this.results.map((row: any) => ({
                test_id: row.test_id,
                test_type: row.test_type,
                question_type: row.question_type,
                question: row.question,
                source_file: row.source_file
            }));
            this.selectedType = 'ALL';
            this.recalculateSummary();
            this.notice = this.sourceRunId + ' 저장 결과를 불러왔습니다. Ollama를 다시 호출하지 않았습니다.';
        } else {
            this.error = this.errorMessage(response, '저장된 OBJECTIVE 결과를 불러오지 못했습니다.');
        }
        this.loading = false;
        await this.service.render();
    }

    public async loadSavedGptRuns() {
        const response: any = await wiz.call('gpt_runs', {});
        this.savedGptRuns = response && response.code === 200
            ? response.data.runs || []
            : [];
        if (!this.savedGptRuns.some((run: any) => run.run_id === this.selectedGptRunId)) {
            this.selectedGptRunId = this.savedGptRuns.length ? this.savedGptRuns[0].run_id : '';
        }
    }

    public async loadSavedGptRun() {
        if (!this.selectedGptRunId || this.running || this.gptRunning) return;
        this.loading = true;
        this.error = '';
        this.notice = '';
        await this.service.render();
        const response: any = await wiz.call('load_gpt', { run_id: this.selectedGptRunId });
        if (response && response.code === 200 && response.data.run) {
            const document = response.data.run;
            const execution = document.execution || {};
            this.resetRun();
            this.runModel = execution.generator_model || this.benchmark.model;
            if (this.objectiveModels.some((item: any) => item.name === this.runModel)) {
                this.selectedModel = this.runModel;
            }
            this.sourceRunId = execution.source_rule_run_id || '';
            this.gptRunScope = execution.evaluation_scope || 'pilot_5';
            this.gptRunStartedAt = execution.started_at || '';
            this.gptRunCompletedAt = execution.completed_at || document.generated_at || '';
            this.results = (document.results || []).map((row: any) => Object.assign({}, row, {
                status: row.rule_status || 'PARSE_ERROR',
                automatic_status: row.rule_status || 'PARSE_ERROR',
                manual_review: {}
            }));
            this.cases = this.results.map((row: any) => ({
                test_id: row.test_id,
                test_type: row.test_type,
                question_type: row.question_type,
                question: row.question,
                source_file: row.source_file
            }));
            this.selectedType = 'ALL';
            this.recalculateSummary();
            const attempted = this.gptSummary.attempted;
            const pilotTarget = Math.min(5, this.gptSummary.eligible_fill_wrong);
            this.gptPilotCompleted = attempted >= pilotTarget;
            this.notice = this.selectedGptRunId + ' GPT-assisted 결과를 불러왔습니다. 외부 모델을 다시 호출하지 않았습니다.';
        } else {
            this.error = this.errorMessage(response, '저장된 GPT-assisted 결과를 불러오지 못했습니다.');
        }
        this.loading = false;
        await this.service.render();
    }

    public async startEvaluation() {
        if (
            this.running || this.gptRunning || !this.benchmark.available ||
            !this.cases.length || !this.selectedModelAvailable()
        ) return;
        this.resetRun();
        this.runModel = this.selectedModel;
        this.error = '';
        this.notice = '';
        this.cancelRequested = false;
        this.runStartedAt = new Date().toISOString();
        this.running = true;
        await this.service.render();

        for (const item of this.cases) {
            if (this.cancelRequested) break;
            this.activeCase = item;
            await this.service.render();
            const requestStartedAt = Date.now();
            const response: any = await wiz.call('evaluate', {
                test_id: item.test_id,
                model: this.runModel
            });
            let result: any;
            if (response && response.code === 200 && response.data.result) {
                result = response.data.result;
            } else {
                result = {
                    test_id: item.test_id,
                    test_type: item.test_type,
                    question_type: item.question_type,
                    question: item.question,
                    generator_model: this.runModel,
                    gemma_answer: '',
                    ground_truth: '',
                    status: 'API_ERROR',
                    scorable: false,
                    raw_response: '',
                    source_file: item.source_file,
                    response_time_ms: Date.now() - requestStartedAt,
                    error: this.errorMessage(response, 'Ollama 평가 요청에 실패했습니다.'),
                    metrics: {}
                };
            }
            result.automatic_status = result.automatic_status || result.status;
            result.manual_review = result.manual_review || {};
            this.results.push(result);
            this.recalculateSummary();
            await this.service.render();
        }

        this.activeCase = null;
        this.running = false;
        this.runCompletedAt = new Date().toISOString();
        this.notice = this.cancelRequested
            ? this.results.length + '건에서 평가를 중지했습니다.'
            : this.results.length + '건의 OBJECTIVE 평가를 완료했습니다.';
        await this.service.render();
        if (this.results.length) await this.saveResults('json', true);
    }

    public async stopEvaluation() {
        if (!this.running) return;
        this.cancelRequested = true;
        this.notice = '현재 문제 응답이 끝난 뒤 중지합니다.';
        await this.service.render();
    }

    public gptJudgeConfig() {
        return (this.benchmark.gpt_assisted && this.benchmark.gpt_assisted.openai_judge) || {};
    }

    public ruleStatus(result: any) {
        return result ? (result.rule_status || result.automatic_status || result.status) : '';
    }

    public isGptEligible(result: any) {
        return !!(result && result.question_type === 'Fill' && this.ruleStatus(result) === 'WRONG');
    }

    public gptEligibleCount() {
        return this.results.filter((row: any) => this.isGptEligible(row)).length;
    }

    public gptPendingCount() {
        return this.results.filter((row: any) =>
            this.isGptEligible(row) && !(row.gpt_judge && row.gpt_judge.attempted)
        ).length;
    }

    public async runGptAssisted(scope: string) {
        if (this.running || this.gptRunning || !this.results.length) return;
        if (scope === 'full' && !this.gptPilotCompleted) {
            this.error = '먼저 Fill 오답 5문항 GPT 테스트를 실행해주세요.';
            await this.service.render();
            return;
        }
        if (!this.gptJudgeConfig().api_key_configured) {
            this.error = '서버의 OPENAI_API_KEY 환경변수를 설정해주세요.';
            await this.service.render();
            return;
        }
        let targets = this.results.filter((row: any) =>
            this.isGptEligible(row) && !(row.gpt_judge && row.gpt_judge.attempted)
        );
        if (scope === 'pilot_5') {
            targets = targets.slice(0, Number(this.benchmark.gpt_assisted?.pilot_limit || 5));
        }
        if (!targets.length) {
            this.notice = '추가로 GPT Judge를 실행할 Fill 오답이 없습니다.';
            if (scope === 'pilot_5') this.gptPilotCompleted = true;
            await this.service.render();
            return;
        }

        this.error = '';
        this.notice = '';
        this.gptRunScope = scope === 'full' ? 'full' : 'pilot_5';
        this.gptRunStartedAt = new Date().toISOString();
        this.gptRunCompletedAt = '';
        this.gptRunning = true;
        const runToken = 'objective-gpt-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        await this.service.render();

        for (const result of targets) {
            this.gptActiveResult = result;
            await this.service.render();
            const response: any = await wiz.call('evaluate_gpt', {
                test_id: result.test_id,
                gemma_answer: result.gemma_answer || '',
                raw_response: result.raw_response || '',
                generator_model: result.generator_model || this.runModel,
                request_token: runToken + ':' + result.test_id
            });
            if (response && response.code === 200 && response.data.result) {
                Object.assign(result, response.data.result);
            } else {
                result.rule_status = this.ruleStatus(result);
                result.gpt_assisted_status = result.rule_status;
                result.gpt_judge = {
                    eligible: true,
                    attempted: true,
                    called: false,
                    decision: 'API_ERROR',
                    reason: '',
                    error_type: 'APPLICATION_API_ERROR',
                    error: this.errorMessage(response, 'GPT-assisted 평가 API 요청에 실패했습니다.'),
                    model: this.gptJudgeConfig().model || '',
                    metrics: {}
                };
            }
            this.recalculateGptSummary();
            await this.service.render();
        }

        this.gptActiveResult = null;
        this.gptRunning = false;
        this.gptRunCompletedAt = new Date().toISOString();
        if (scope === 'pilot_5') this.gptPilotCompleted = true;
        this.recalculateGptSummary();
        this.notice = scope === 'pilot_5'
            ? targets.length + '건의 GPT 파일럿 평가를 완료했습니다.'
            : targets.length + '건의 나머지 GPT 평가를 완료했습니다.';
        await this.service.render();
        await this.saveGptResults('json', true);
    }

    public async saveGptResults(format: string, automatic: boolean = false) {
        if (!this.results.length || this.running || this.gptRunning || !this.gptSummary.attempted) return;
        if (!automatic) {
            this.error = '';
            this.notice = '';
        }
        const response: any = await wiz.call('save_gpt', {
            format: format,
            results: JSON.stringify(this.results),
            metadata: JSON.stringify({
                evaluation_scope: this.gptRunScope,
                generator_model: this.runModel || this.selectedModel,
                source_rule_run_id: this.sourceRunId,
                started_at: this.gptRunStartedAt,
                completed_at: this.gptRunCompletedAt || new Date().toISOString()
            })
        });
        if (response && response.code === 200 && response.data.saved) {
            this.gptSavedFiles.unshift(response.data.saved);
            this.notice = 'GPT-assisted ' + format.toUpperCase() + ' 결과를 별도 저장했습니다.';
            if (format === 'json') await this.loadSavedGptRuns();
        } else {
            this.error = this.errorMessage(response, 'GPT-assisted 결과를 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public async setResultFilter(value: string) {
        this.resultFilter = value;
        await this.service.render();
    }

    public async selectResult(result: any) {
        this.selectedResult = this.selectedResult === result ? null : result;
        this.manualReviewNote = this.selectedResult && this.selectedResult.manual_review
            ? this.selectedResult.manual_review.note || ''
            : '';
        await this.service.render();
    }

    public async openManualReview(result: any, event?: Event) {
        if (event) event.stopPropagation();
        this.selectedResult = result;
        this.manualReviewNote = result && result.manual_review
            ? result.manual_review.note || ''
            : '';
        await this.service.render();
    }

    public async closeManualReview() {
        this.selectedResult = null;
        this.manualReviewNote = '';
        await this.service.render();
    }

    public async approveManualPass() {
        const result = this.selectedResult;
        if (!this.canManualApprove(result) || this.running || this.gptRunning) return;
        const automaticStatus = result.automatic_status || result.status;
        result.automatic_status = automaticStatus;
        result.manual_review = {
            decision: 'PASS',
            previous_status: automaticStatus,
            note: String(this.manualReviewNote || '').trim(),
            reviewed_at: new Date().toISOString()
        };
        result.status = 'PASS';
        result.scorable = true;
        this.recalculateSummary();
        this.notice = result.test_id + '을(를) 수동 PASS로 승인했습니다. 저장 버튼으로 검토 결과를 보존하세요.';
        await this.service.render();
    }

    public async undoManualPass() {
        const result = this.selectedResult;
        if (!result || !this.isManualPass(result) || this.running || this.gptRunning) return;
        result.status = result.automatic_status || result.manual_review.previous_status || 'WRONG';
        result.scorable = result.status === 'PASS' || result.status === 'WRONG';
        result.manual_review = {};
        this.manualReviewNote = '';
        this.recalculateSummary();
        this.notice = result.test_id + '의 수동 승인을 취소하고 자동 판정으로 복원했습니다.';
        await this.service.render();
    }

    public isManualPass(result: any) {
        return !!(
            result && result.status === 'PASS' && result.manual_review &&
            result.manual_review.decision === 'PASS' && result.automatic_status !== 'PASS'
        );
    }

    public canManualApprove(result: any) {
        return !!(
            result && result.status !== 'PASS' && result.ground_truth &&
            (result.gemma_answer || result.raw_response)
        );
    }

    public filteredResults() {
        if (this.resultFilter === 'ALL') return this.results;
        if (this.resultFilter === 'ISSUES') {
            return this.results.filter((row: any) => row.status !== 'PASS');
        }
        if (this.resultFilter === 'ERRORS') {
            return this.results.filter((row: any) =>
                ['PARSE_ERROR', 'GOLD_ERROR', 'API_ERROR'].indexOf(row.status) >= 0
            );
        }
        if (this.resultFilter === 'GPT_PASS') {
            return this.results.filter((row: any) =>
                row.gpt_judge && row.gpt_judge.decision === 'PASS'
            );
        }
        if (this.resultFilter === 'GPT_AMBIGUOUS') {
            return this.results.filter((row: any) =>
                row.gpt_judge && row.gpt_judge.decision === 'AMBIGUOUS'
            );
        }
        if (this.resultFilter === 'GPT_ERRORS') {
            return this.results.filter((row: any) =>
                row.gpt_judge && ['API_ERROR', 'PARSE_ERROR'].indexOf(row.gpt_judge.decision) >= 0
            );
        }
        if (this.resultFilter === 'MANUAL_PASS') {
            return this.results.filter((row: any) => this.isManualPass(row));
        }
        return this.results.filter((row: any) => row.status === this.resultFilter);
    }

    public async saveResults(format: string, automatic: boolean = false) {
        if (!this.results.length || this.running || this.gptRunning) return;
        if (!automatic) {
            this.error = '';
            this.notice = '';
        }
        const response: any = await wiz.call('save', {
            format: format,
            results: JSON.stringify(this.results),
            metadata: JSON.stringify(this.executionMetadata())
        });
        if (response && response.code === 200 && response.data.saved) {
            this.savedFiles.unshift(response.data.saved);
            this.notice = format.toUpperCase() + ' 결과를 서버에 저장했습니다.';
            if (!automatic) this.downloadResults(format);
        } else {
            this.error = this.errorMessage(response, 'OBJECTIVE 결과를 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public downloadResults(format: string) {
        if (!this.results.length) return;
        const stamp = new Date().toISOString().replace(/[:.]/g, '-');
        let body = '';
        let mime = '';
        if (format === 'csv') {
            const fields = [
                'test_id', 'question_type', 'question', 'generator_model',
                'gemma_answer', 'ground_truth',
                'automatic_status', 'status', 'manual_review_decision',
                'manual_review_note', 'manual_reviewed_at', 'scorable',
                'response_time_ms', 'raw_response', 'error'
            ];
            const rows = [fields.join(',')];
            for (const result of this.results) {
                const review = result.manual_review || {};
                const flat: any = Object.assign({}, result, {
                    manual_review_decision: review.decision || '',
                    manual_review_note: review.note || '',
                    manual_reviewed_at: review.reviewed_at || ''
                });
                rows.push(fields.map((field: string) => this.csvCell(flat[field])).join(','));
            }
            body = '\ufeff' + rows.join('\n');
            mime = 'text/csv;charset=utf-8';
        } else {
            body = JSON.stringify({
                schema_version: 2,
                scoring_version: this.benchmark.scoring_version || 'objective-v2',
                run_kind: 'objective_manual_review',
                execution: this.executionMetadata(),
                summary: this.summary,
                results: this.results
            }, null, 2);
            mime = 'application/json;charset=utf-8';
        }
        const blob = new Blob([body], { type: mime });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'fab-bench-objective-reviewed-' + stamp + '.' + format;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(url);
    }

    public progressPercent() {
        return this.cases.length
            ? Math.min(100, Math.round((this.results.length / this.cases.length) * 100))
            : 0;
    }

    public gptProgressPercent() {
        return this.gptSummary.eligible_fill_wrong
            ? Math.min(100, Math.round((this.gptSummary.attempted / this.gptSummary.eligible_fill_wrong) * 100))
            : 0;
    }

    public typeCount(type: string) {
        return (this.benchmark.counts && this.benchmark.counts[type]) || 0;
    }

    public typeSummaryRows() {
        const byType = this.summary.by_type || {};
        return ['Judge', 'Choice', 'Fill', 'Calculation'].map((type: string) => Object.assign(
            this.emptyTypeSummary(), byType[type] || {}, { type: type }
        ));
    }

    public displayType(type: string) {
        return type === 'Calculation' ? 'Calculate' : type;
    }

    public statusClass(result: any) {
        if (this.isManualPass(result)) return 'bg-violet-100 text-violet-800';
        if (result.status === 'PASS') return 'bg-emerald-50 text-emerald-700';
        if (result.status === 'WRONG') return 'bg-rose-50 text-rose-700';
        if (result.status === 'API_ERROR') return 'bg-fuchsia-50 text-fuchsia-700';
        return 'bg-amber-50 text-amber-700';
    }

    public statusLabel(result: any) {
        return this.isManualPass(result) ? 'PASS · 수동' : result.status;
    }

    public gptDecision(result: any) {
        if (!this.isGptEligible(result)) return 'RULE 유지';
        return result.gpt_judge ? result.gpt_judge.decision || '대기' : '대기';
    }

    public gptDecisionClass(result: any) {
        const decision = result && result.gpt_judge ? result.gpt_judge.decision : '';
        if (decision === 'PASS') return 'bg-emerald-50 text-emerald-700';
        if (decision === 'WRONG') return 'bg-rose-50 text-rose-700';
        if (decision === 'AMBIGUOUS') return 'bg-amber-50 text-amber-700';
        if (decision === 'API_ERROR' || decision === 'PARSE_ERROR') return 'bg-fuchsia-50 text-fuchsia-700';
        return 'bg-slate-100 text-slate-500';
    }

    public formatDate(value: string) {
        return value ? new Date(value).toLocaleString('ko-KR') : '-';
    }

    public trackResult(index: number, result: any) {
        return result.test_id;
    }

    private resetRun() {
        this.results = [];
        this.summary = this.emptySummary();
        this.selectedResult = null;
        this.manualReviewNote = '';
        this.resultFilter = 'ALL';
        this.savedFiles = [];
        this.runModel = '';
        this.runStartedAt = '';
        this.runCompletedAt = '';
        this.cancelRequested = false;
        this.activeCase = null;
        this.sourceRunId = '';
        this.sourceBaselineName = '';
        this.gptSummary = this.emptyGptSummary();
        this.gptRunning = false;
        this.gptPilotCompleted = false;
        this.gptActiveResult = null;
        this.gptRunScope = 'pilot_5';
        this.gptRunStartedAt = '';
        this.gptRunCompletedAt = '';
        this.gptSavedFiles = [];
    }

    private recalculateSummary() {
        const summarize = (rows: any[]) => {
            const passRows = rows.filter((row: any) => row.status === 'PASS');
            const manualPass = passRows.filter((row: any) => this.isManualPass(row)).length;
            const wrong = rows.filter((row: any) => row.status === 'WRONG').length;
            const parseError = rows.filter((row: any) => row.status === 'PARSE_ERROR').length;
            const goldError = rows.filter((row: any) => row.status === 'GOLD_ERROR').length;
            const apiError = rows.filter((row: any) => row.status === 'API_ERROR').length;
            const graded = passRows.length + wrong;
            return {
                total: rows.length,
                graded: graded,
                pass: passRows.length,
                automatic_pass: passRows.length - manualPass,
                manual_pass: manualPass,
                wrong: wrong,
                parse_error: parseError,
                gold_error: goldError,
                api_error: apiError,
                errors: parseError + goldError + apiError,
                accuracy: graded ? Number(((passRows.length / graded) * 100).toFixed(2)) : 0
            };
        };
        const summary: any = summarize(this.results);
        summary.by_type = {};
        for (const type of ['Judge', 'Choice', 'Fill', 'Calculation']) {
            summary.by_type[type] = summarize(
                this.results.filter((row: any) => row.question_type === type)
            );
        }
        const durations = this.results
            .map((row: any) => Number(row.response_time_ms || 0))
            .filter((value: number) => value > 0);
        summary.average_response_time_ms = durations.length
            ? Number((durations.reduce((sum: number, value: number) => sum + value, 0) / durations.length).toFixed(2))
            : 0;
        this.summary = summary;
        this.recalculateGptSummary();
    }

    private recalculateGptSummary() {
        const ruleStatuses = this.results.map((row: any) => this.ruleStatus(row));
        const rulePass = ruleStatuses.filter((status: string) => status === 'PASS').length;
        const ruleWrong = ruleStatuses.filter((status: string) => status === 'WRONG').length;
        const eligible = this.results.filter((row: any) => this.isGptEligible(row));
        const decisions: any = {
            PASS: 0, WRONG: 0, AMBIGUOUS: 0, API_ERROR: 0, PARSE_ERROR: 0
        };
        const usage: any = {
            api_request_count: 0, input_tokens: 0, cached_input_tokens: 0,
            output_tokens: 0, total_tokens: 0, estimated_cost_usd: 0,
            total_duration_ms: 0
        };
        let attempted = 0;
        for (const row of eligible) {
            const judge = row.gpt_judge || {};
            if (judge.attempted) attempted += 1;
            if (decisions[judge.decision] !== undefined) decisions[judge.decision] += 1;
            const metrics = judge.metrics || {};
            for (const field of [
                'api_request_count', 'input_tokens', 'cached_input_tokens',
                'output_tokens', 'total_tokens', 'total_duration_ms'
            ]) {
                usage[field] += Number(metrics[field] || 0);
            }
            usage.estimated_cost_usd += Number(metrics.estimated_cost_usd || 0);
        }
        const graded = rulePass + ruleWrong;
        const assistedPass = rulePass + decisions.PASS;
        const ruleAccuracy = graded ? Number(((rulePass / graded) * 100).toFixed(2)) : 0;
        const assistedAccuracy = graded ? Number(((assistedPass / graded) * 100).toFixed(2)) : 0;
        usage.estimated_cost_usd = Number(usage.estimated_cost_usd.toFixed(8));
        this.gptSummary = {
            eligible_fill_wrong: eligible.length,
            attempted: attempted,
            not_attempted: Math.max(0, eligible.length - attempted),
            wrong_to_pass: decisions.PASS,
            wrong_to_ambiguous: decisions.AMBIGUOUS,
            gpt_wrong: decisions.WRONG,
            gpt_api_error: decisions.API_ERROR,
            gpt_parse_error: decisions.PARSE_ERROR,
            rule_accuracy: ruleAccuracy,
            gpt_assisted_accuracy: assistedAccuracy,
            accuracy_delta: Number((assistedAccuracy - ruleAccuracy).toFixed(2)),
            openai_usage: usage
        };
    }

    private emptyTypeSummary() {
        return {
            total: 0, graded: 0, pass: 0, automatic_pass: 0, manual_pass: 0,
            wrong: 0, parse_error: 0, gold_error: 0, api_error: 0, errors: 0,
            accuracy: 0
        };
    }

    private emptySummary() {
        const summary: any = this.emptyTypeSummary();
        summary.average_response_time_ms = 0;
        summary.by_type = {
            Judge: this.emptyTypeSummary(), Choice: this.emptyTypeSummary(),
            Fill: this.emptyTypeSummary(), Calculation: this.emptyTypeSummary()
        };
        return summary;
    }

    private emptyGptSummary() {
        return {
            eligible_fill_wrong: 0, attempted: 0, not_attempted: 0,
            wrong_to_pass: 0, wrong_to_ambiguous: 0, gpt_wrong: 0,
            gpt_api_error: 0, gpt_parse_error: 0,
            rule_accuracy: 0, gpt_assisted_accuracy: 0, accuracy_delta: 0,
            openai_usage: {
                api_request_count: 0, input_tokens: 0, cached_input_tokens: 0,
                output_tokens: 0, total_tokens: 0, estimated_cost_usd: 0,
                total_duration_ms: 0
            }
        };
    }

    private executionMetadata() {
        return {
            model: this.runModel || this.selectedModel,
            temperature: 0,
            problem_count: this.results.length,
            started_at: this.runStartedAt,
            completed_at: this.runCompletedAt || new Date().toISOString(),
            selected_type: this.selectedType,
            manual_review_count: this.summary.manual_pass,
            source_run_id: this.sourceRunId,
            source_baseline_name: this.sourceBaselineName,
            cancelled: this.cancelRequested,
            rag_enabled: false,
            context_enabled: false,
            stream: false
        };
    }

    private csvCell(value: any) {
        const text = String(value === undefined || value === null ? '' : value);
        return '"' + text.replace(/"/g, '""') + '"';
    }

    private errorMessage(response: any, fallback: string) {
        if (response && response.data && response.data.message) return response.data.message;
        if (response && response.responseJSON && response.responseJSON.data) {
            return response.responseJSON.data.message || fallback;
        }
        return fallback;
    }
}

export default PageFabbenchObjectiveComponent;